export default __webpack_public_path__ + "static/media/card_client_sa_cx.2d7ce8bb.png";